export const modules = {
    quill: {
        load: () => import(
        /* webpackPreload: true */
        './QuillTextEditor'),
    },
    prosemirror: {
        load: () => import(
        /* webpackPreload: true */
        './ProseTextEditor'),
    },
};
